export default __webpack_public_path__ + "static/media/009-table tennis.d8ea5efc.svg";